var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading || !_vm.hasAvatar)?_c('BaseAvatar',{attrs:{"display-name":_vm.displayName,"size":_vm.size,"disable-tooltip":_vm.disableTooltip}}):_c('BaseAvatar',{attrs:{"display-name":_vm.displayName,"url":_vm.avatarUrl,"size":_vm.size,"disable-tooltip":_vm.disableTooltip}})
}
var staticRenderFns = []

export { render, staticRenderFns }